import { IAMSession, IAMUser } from '@sls-react/typings/services/iam/auth';
import fetcher, { makeFetcher } from '@sls-react/api/fetcher';
import getUTMsFromCookies from '@sls-react/services/analytics/getUTMsFromCookies';
import { RailsSessionUser } from '@sls-react/typings/services/rails/session';

export const recaptchaHeader = 'g-recaptcha-token';

export const fetchV1Session = makeFetcher<{ user: RailsSessionUser }>(
  () => '/v1/session',
);

export const fetchIamUser = makeFetcher<IAMUser>(() => ({ uuid }) =>
  `/iam/v1/auth/user/${uuid}`,
);

export const updateAccountSettings = (values: any) =>
  fetcher<IAMUser>(({ sub }) => `/iam/v1/auth/user/${sub}`, {
    method: 'put',
    body: { ...values },
  });

export const postAttributions = async () => {
  const attribution = getUTMsFromCookies();
  if (!attribution) {
    return;
  }

  return await fetcher(({ uuid }) => `/v1/users/${uuid}/attributions`, {
    method: 'post',
    body: {
      attribution,
    },
  });
};

export const fetchIamUserSessions = makeFetcher<IAMSession[]>(
  (platform: 'ios' | 'android') => [
    ({ uuid }) => `/iam/v1/auth/user/${uuid}/sessions`,
    {
      params: {
        platform,
        limit: 1,
      },
    },
  ],
);
